import React, { useState } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { useAppSelector } from '../../../../hooks/store-hooks';
import { useUIService } from '../../../../../use-cases/ui';
import { Collapse, List } from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { useNavigate } from 'react-router-dom';
import { ITipoUsuario } from '../../../../../application/models';
import { useNavigationService } from '../../../../../use-cases/navigation';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BarChartIcon from '@mui/icons-material/BarChart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PieChartIcon from '@mui/icons-material/PieChart';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import PhonelinkOffIcon from '@mui/icons-material/PhonelinkOff';

const ListItems = () => {
  // State
  const { activePage } = useAppSelector((state) => state.ui)
  const { currentUser } = useAppSelector((state) => state.user)
  // Useful variables
  const isVelesUser = currentUser?.IdVelesPerfilInterno !== ITipoUsuario.USUARIO_CLIENTE
  const isDemaisUser = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_DEMAIS
  const isTecnologiaDaInformacaoUser = currentUser?.IdVelesPerfilInterno === ITipoUsuario.TECNOLOGIA_DA_INFORMACAO
  const isComercialUser = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_COMERCIAL
  // Use State
  const [cadastroOpen, setCadastroOpen] = useState(false);
  const [travasOpen, setTravasOpen] = useState(false);
  const [relatoriosOpen, setRelatoriosOpen] = useState(false);
  // Service
  const { setActivePage } = useUIService()
  const { navigateTo } = useNavigationService()
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <ListItemButton
        selected={activePage === 'Dashboard/Home'}
        onClick={() => {
          setActivePage({
            pageKey: 'Dashboard/Home'
          })
          navigate('/dashboard')
        }}
      >
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>

      <ListItemButton
        onClick={() => {
          setCadastroOpen(!cadastroOpen)
        }}
      >
        <ListItemIcon>
          <AppRegistrationIcon />
        </ListItemIcon>
        <ListItemText primary="Cadastros" />
        {
          cadastroOpen ? <ExpandLess /> : <ExpandMore />
        }
      </ListItemButton>
      <Collapse in={cadastroOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            selected={activePage === 'Dashboard/Cadastro/Cliente'}
            sx={{
              pl: 4
            }}
            onClick={() => {
              setActivePage({
                pageKey: 'Dashboard/Cadastro/Cliente'
              })
              navigate('/dashboard/cadastro/cliente')
            }}
          >
            <ListItemIcon>
              <ApartmentIcon />
            </ListItemIcon>
            <ListItemText primary={isVelesUser ? "Clientes" : "Cliente"} />
          </ListItemButton>

          <ListItemButton
            selected={activePage === 'Dashboard/Cadastro/Perfil'}
            sx={{
              pl: 4
            }}
            onClick={() => {
              setActivePage({
                pageKey: 'Dashboard/Cadastro/Perfil'
              })
              navigate('/dashboard/cadastro/perfil')
            }}
          >
            <ListItemIcon>
              <ManageAccountsIcon />
            </ListItemIcon>
            <ListItemText primary="Perfil" />
          </ListItemButton>

          <ListItemButton
            selected={activePage === 'Dashboard/Cadastro/Usuario'}
            sx={{
              pl: 4
            }}
            onClick={() => {
              setActivePage({
                pageKey: 'Dashboard/Cadastro/Usuario'
              })
              navigate('/dashboard/cadastro/usuario')
            }}
          >
            <ListItemIcon>
              <PeopleAltIcon />
            </ListItemIcon>
            <ListItemText primary="Usuários" />
          </ListItemButton>
        </List>
      </Collapse>

      <ListItemButton
        onClick={() => setTravasOpen(!travasOpen)}
      >
        <ListItemIcon>
          <LockOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Travas" />
        {
          travasOpen ? <ExpandLess /> : <ExpandMore />
        }
      </ListItemButton>
      <Collapse in={travasOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            selected={activePage === 'Dashboard/Travas/Trava-Consumo'}
            sx={{
              pl: 4
            }}
            onClick={() => {
              setActivePage({
                pageKey: 'Dashboard/Travas/Trava-Consumo'
              })
              navigateTo({
                route: '/dashboard/trava/consumo'
              })
            }}
          >
            <ListItemIcon>
              <TrendingUpIcon />
            </ListItemIcon>
            <ListItemText primary="Limite de Consumo" />
          </ListItemButton>

          <ListItemButton
            selected={activePage === 'Dashboard/Travas/IP'}
            sx={{
              pl: 4
            }}
            onClick={() => {
              setActivePage({
                pageKey: 'Dashboard/Travas/IP'
              })
              navigateTo({
                route: '/dashboard/trava/ip-permitido'
              })
            }}
          >
            <ListItemIcon>
              <PhonelinkOffIcon />
            </ListItemIcon>
            <ListItemText primary="IP" />
          </ListItemButton>
        </List>
      </Collapse>

      <ListItemButton
        onClick={() => setRelatoriosOpen(!relatoriosOpen)}
      >
        <ListItemIcon>
          <AssessmentIcon />
        </ListItemIcon>
        <ListItemText primary="Relatórios" />
        {
          relatoriosOpen ? <ExpandLess /> : <ExpandMore />
        }
      </ListItemButton>
      <Collapse in={relatoriosOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            selected={activePage === 'Dashboard/Relatorios/Dashboard'}
            sx={{
              pl: 4
            }}
            onClick={() => {
              setActivePage({
                pageKey: 'Dashboard/Relatorios/Dashboard'
              })
              navigate('/dashboard/relatorios/sintetico-quantitativo')
            }}
          >
            <ListItemIcon>
              <BarChartIcon />
            </ListItemIcon>
            <ListItemText primary="Sintético e Quantitativo" />
          </ListItemButton>

          {(isDemaisUser || isTecnologiaDaInformacaoUser) && (
            <ListItemButton
              selected={activePage === 'Dashboard/Relatorios/Receitas'}
              sx={{
                pl: 4
              }}
              onClick={() => {
                setActivePage({
                  pageKey: 'Dashboard/Relatorios/Receitas'
                })
                navigate('/dashboard/relatorios/receitas')
              }}
            >
              <ListItemIcon>
                <AttachMoneyIcon />
              </ListItemIcon>
              <ListItemText primary="Receita" />
            </ListItemButton>
          )}

          {!isComercialUser && (
            <ListItemButton
              selected={activePage === 'Dashboard/Relatorios/Consumo-Analiticos'}
              sx={{
                pl: 4
              }}
              onClick={() => {
                setActivePage({
                  pageKey: 'Dashboard/Relatorios/Consumo-Analiticos'
                })
                navigate('/dashboard/relatorios/analiticos')
              }}
            >
              <ListItemIcon>
                <AnalyticsIcon />
              </ListItemIcon>
              <ListItemText primary="Analítico" />
            </ListItemButton>
          )}
          
          {!isComercialUser && (
            <ListItemButton
              selected={activePage === 'Dashboard/Relatorios/Acessos'}
              sx={{
                pl: 4
              }}
              onClick={() => {
                setActivePage({
                  pageKey: 'Dashboard/Relatorios/Acessos'
                })
                navigate('/dashboard/relatorios/acessos')
              }}
            >
              <ListItemIcon>
                <AnalyticsIcon />
              </ListItemIcon>
              <ListItemText primary="Acessos" />
            </ListItemButton>
          )}
        </List>
      </Collapse>
    </React.Fragment >
  );
};

export default ListItems;
